import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_quill_editor = _resolveComponent("quill-editor")!
  const _component_n_gi = _resolveComponent("n-gi")!
  const _component_n_code = _resolveComponent("n-code")!
  const _component_n_scrollbar = _resolveComponent("n-scrollbar")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_n_grid = _resolveComponent("n-grid")!

  return (_openBlock(), _createBlock(_component_n_grid, {
    "x-gap": "12",
    cols: 2
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_gi, { style: {"height":"fit-content"} }, {
        default: _withCtx(() => [
          _createVNode(_component_quill_editor, {
            ref: "editor",
            content: _ctx.content,
            "onUpdate:content": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.content) = $event)),
            options: _ctx.options
          }, null, 8, ["content", "options"])
        ]),
        _: 1
      }),
      _createVNode(_component_n_gi, { style: {"height":"100%"} }, {
        default: _withCtx(() => [
          _createVNode(_component_n_card, { style: {"height":"100%"} }, {
            default: _withCtx(() => [
              _createVNode(_component_n_scrollbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_n_code, {
                    code: _ctx.sqf,
                    language: "sqf"
                  }, null, 8, ["code"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}